import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ReusableImageSelector from "../components/media/ReusableImageSelector";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import BlockHolder from "./BlockHolder";
import { API_ENDPOINT } from "../utils/constants";
const MediaSelector = ({
  type = "image",
  onChange,
  onMediaSelector,
  resetTrue,
}) => {
  const [mediaUrl, setMediaUrl] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const prevTypeRef = useRef(type);
  useEffect(() => {
    if (prevTypeRef.current !== type) {
      setMediaUrl("");
      onChange?.("");
      prevTypeRef.current = type;
    }
  }, [type]);
  useEffect(() => {
    if (resetTrue) {
      setMediaUrl("");
    }
  }, [resetTrue]);
  return (
    <BlockHolder>
      <Button
        startIcon={<PermMediaIcon />}
        onClick={handleOpen}
        variant="outlined"
        size="small"
      >
        Choose {type}
      </Button>
      <ReusableImageSelector
        url={`${API_ENDPOINT}/upload/get-all-media?type=${type}`}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        onSelect={(img) => {
          setMediaUrl(img.url);
          onChange?.(img.url);
          onMediaSelector?.(img);
        }}
        type={type}
      />
      {mediaUrl && (
        <Typography my={1} variant="caption">
          {mediaUrl}
        </Typography>
      )}
    </BlockHolder>
  );
};

export default MediaSelector;
